'use client';

import { useEffect, useRef } from 'react';
import useAccount from '@/lib/hooks/useAccount';
import useSwrClearCache from '@/hooks/useSwrClearCache';

// EWM-652 — behavioural atom (renders null, like gtm-init / data-layer-provider).
// Tears down a rejected/misconfigured session on mount: logs out via the BFF and
// clears the SWR cache, so a customer who authenticated but isn't provisioned for
// B2B is not left half-authenticated (the account gate refuses to render the app
// for them). It deliberately does NOT redirect or refresh — the accompanying
// "contact customer service" notice must stay visible; the notice's CTA is how
// the (now guest) user leaves.
const SessionTeardown = () => {
  const { logout } = useAccount();
  const clearCache = useSwrClearCache();
  const torndown = useRef(false);

  useEffect(() => {
    if (torndown.current) return; // once per mount — logout is not idempotent-cheap
    torndown.current = true;
    logout()
      .then(() => clearCache())
      .catch(() => {
        // Best-effort. The gate already refuses to render the app for this
        // session, so a failed teardown still leaves the user on the notice.
      });
  }, [logout, clearCache]);

  return null;
};

export default SessionTeardown;
